import IFrame from '@/views/IFrame'
import OfferTable from '@/views/residences/OfferTable'
import ResidencesView from '@/views/residences/ResidencesView'

export default [
  {
    name: 'residences-list',
    path: '/residences/',
    component: ResidencesView
  },
  {
    name: 'residences',
    path: '/residences/:id/reservation-d-un-logement',
    component: OfferTable
  },
  {
    name: 'iframe',
    path: '/residences/:id/disponibilites',
    component: IFrame
  }
]
